<template>
  <div class="gift-action">
    <div class="row mb15 clearfix">
      <span class="label">最近玩过：</span>
      <template v-if="isLogin">
        <span
          v-for="(item, i) in recentlyPlayed"
          :key="item.game_id"
          class="item ellipsis-1"
          :class="{ cur: cur === -2 - i }"
          :title="item.title"
          @click="
            cur = -2 - i
            curGameIds = item.game_id
            $util.clickStat(`LBZX/ZJWG${i + 1}`, `礼包中心/最近玩过${i + 1}`)
          "
          >{{ item.title }}</span
        >
      </template>
      <template v-else>
        <span class="item" @click="popLogin">
          <a href="javascript:;">请先登录</a>
        </span>
      </template>
      <Input
        placeholder="请输入游戏名"
        :list="gameList"
        default-key="title"
        @search="curGameIds = $event.game_id"
        @change="searchKey = $event"
      />
    </div>
    <div class="row mb15">
      <span class="label">按游戏名：</span>
      <span
        class="item"
        :class="{ cur: cur === -1 }"
        @click="
          cur = -1
          curGameIds = 0
          curVip = 0
          $util.clickStat(`LBZX/YXM1`, `礼包中心/游戏名1`)
        "
        >全部游戏</span
      >
      <span
        v-for="(item, i) in letters"
        :key="item"
        class="item"
        :class="{ cur: cur === i }"
        @click="
          cur = i
          curGameIds = getLetterGameIds(item)
          curVip = 0
          $util.clickStat(`LBZX/YXM${i + 2}`, `礼包中心/游戏名${i + 2}`)
        "
        >{{ item }}</span
      >
    </div>
    <div class="row">
      <span class="label">按VIP等级：</span>
      <span
        v-for="i in 10"
        :key="`vip-${i}`"
        class="item"
        :class="{ cur: cur === i + 6 }"
        @click="
          cur = i + 6
          curVip = i
          curGameIds = -1
          $util.clickStat(`LBZX/VIPDJ${i}`, `礼包中心/VIP等级${i}`)
        "
        >VIP{{ i }}</span
      >
    </div>
  </div>
</template>

<script>
import flat from 'lodash.flattendeep'
import Input from '~/components/common/Input'
export default {
  name: 'GiftAction',
  components: {
    Input
  },
  data() {
    return {
      cur: -1,
      gameList: [],
      letters: ['ABCD', 'EGFH', 'IJKL', 'MNOP', 'QRST', 'UVWX', 'YZ'],
      curGameIds: 0,
      curVip: 0,
      searchKey: null
    }
  },
  computed: {
    recentlyPlayed() {
      return this.$store.state.user.recentlyPlayed.slice(0, 6)
    },
    isLogin() {
      return this.$store.getters.isLogin
    },
    gameMap() {
      return this.gameList.reduce((p, c) => {
        const letter = c.game_initial[0].toUpperCase()
        p[letter] ? p[letter].push(c) : (p[letter] = [c])
        return p
      }, {})
    }
  },
  watch: {
    curGameIds(val) {
      this.$emit('change', val)
    },
    curVip(val) {
      this.$emit('change-vip', val)
    }
  },
  methods: {
    getLetterGameIds(letterStr) {
      return (
        flat(
          [...letterStr].reduce((p, c) => {
            if (this.gameMap[c] && this.gameMap[c].length) {
              p.push(this.gameMap[c])
            }
            return p
          }, [])
        )
          .map((e) => e.game_id)
          .join(',') || -1
      )
    },
    popLogin() {
      this.$store.commit('app/setLoginPop', true)
    },
    clientCreated() {
      this.$store.dispatch('user/getRecentlyPlayed')
      this.$request('cateServerList', {
        body: { code_sort: 'sort' }
      }).then((data = []) => {
        this.gameList = data
      })
    }
  }
}
</script>
